import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { THEME as theme } from 'GlobalStyles';

import { useStyles } from './style';

/** @typedef {import('types/app').IconProps} IconProps */

/**
 * @param {IconProps} props
 */
const FPIcon = ({ color = theme.palette.grey[600], onSetColor = null, size = 'md', ...rest }) => {
  const iconColor = (onSetColor && onSetColor(theme.palette)) || color;
  const classes = useStyles({ color: iconColor, size });

  return <SvgIcon classes={classes} {...rest} />;
};

export default FPIcon;
